import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Box, Button, CssBaseline } from '@mui/material';
import Home from './pages/home';
import { BrowserRouter, RouterProvider } from 'react-router-dom';
import RouterConfig from './routes';
import { GamingThemeProvider } from './theme/ThemeContext';


function App() {

  return (
    <GamingThemeProvider>
      <CssBaseline />
      <RouterProvider router={RouterConfig} />
    </GamingThemeProvider>
  )
}

export default App;
